import classnames from 'classnames';
import { omit } from 'lodash-es';
import { CaretDown, CaretUp } from 'phosphor-react';
import type { PropsWithChildren } from 'react';
import type { SortDirection, Sorting } from './sorting';
import { getSortDirection } from './sorting';
import type { THeaderProps } from './table';
import { THeader } from './table';

export type SortableTHeaderProps<C> = THeaderProps & {
  column: C;
  onColumnSortChange: (column: C) => void;
  sorting: Sorting<C>;
};

export function SortableTHeader<C>(props: PropsWithChildren<SortableTHeaderProps<C>>) {
  return (
    <THeader
      onClick={() => props.onColumnSortChange(props.column)}
      contentClassName={classnames('space-x-1 cursor-pointer', props.contentClassName)}
      {...omit(props, 'contentClassName', 'onColumnSortChange', 'sorting')}>
      <span>{props.children}</span>
      <SortDirectionIndicator direction={getSortDirection(props.sorting, props.column)} />
    </THeader>
  );
}

type SortDirectionIndicatorProps = {
  direction?: SortDirection;
};

const SortDirectionIndicator = ({ direction }: SortDirectionIndicatorProps) => {
  if (direction === 'Ascending') {
    return <>
      <span className="sr-only">Aufsteigend sortiert</span>
      <CaretUp size={18} />
    </>;
  }
  if (direction === 'Descending') {
    return <>
      <span className="sr-only">Absteigend sortiert</span>
      <CaretDown size={18} />
    </>;
  }
  return null;
};
